/* import __COLOCATED_TEMPLATE__ from './button.hbs'; */
import Component from '@ember/component';
export default Component.extend({
  tagName: ''
});